import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const TripleIntegralEvaluation = () => (
  <QPhototModuleSubtopic
    title="Evaluation of triple integral"
    videos={[
      "https://www.youtube.com/embed/TVgFQgECUUY"
    ]}
    takeaways={[
      { text: "If limits in terms of (x,y), integrate with respect to dz" },
      { text: "If limits in terms of (y,z), integrate with respect to dx" },
      { text: "If limits in terms of (x,z), integrate with respect to dy" }
    ]}
    questions={[
        {
            image:"/cal_50.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default TripleIntegralEvaluation;
